"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectAmount',
    components: {
        AppButton: AppButton_vue_1.default,
    },
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            amount: this.playerinput.maxByDefault ? String(this.playerinput.max) : String(this.playerinput.min),
        };
    },
    methods: {
        saveData() {
            this.onsave({ type: 'amount', amount: parseInt(this.amount) });
        },
        setMaxValue() {
            this.amount = String(this.playerinput.max);
        },
    },
});
